import styled from 'styled-components';
import { Absolute, Box, Button } from '@rsos/base-components';
import { InputStyles } from '@rsos/base-components/form/inputs/InputText/InputText.styles';

const TEXTAREA_MAX_HEIGHT = 104;

const TextArea = styled.textarea`
  ${InputStyles}
  resize: none;
  overflow: auto;
  max-height: ${TEXTAREA_MAX_HEIGHT}px;
  height: auto;
`;

export const PopoverContainer = styled(Absolute)`
  background-color: ${({ theme }) => theme.colors.background};
  padding: 8px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 400px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  transform: translateX(-50%);
  position: absolute;
  top: auto;
  left: 50%;
  right: auto;
  bottom: 80px;
  max-width: 500px;
  width: 100%;
  z-index: 9999;
  outline: none;
  &:focus {
    outline: none;
  }
`;

export const FieldContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 100%;
  margin-right: 8px;

  &:last-child {
    margin-right: 0;
  }
`;

export const NoteTextArea = styled(TextArea)`
  width: 100%;
  min-height: 60px;
  padding: 12px;
  border-radius: 6px;
  font-size: 14px;
  line-height: 1.5;
  background-color: ${({ theme }) => theme.colors.background};
  font-family: inherit;
  border: 1px solid ${({ theme }) => theme.colors.border};
  color: ${({ theme }) => theme.colors.primaryText};
  resize: none;
`;

// ============================================================================
// Color Selector Styles
// ============================================================================

export const CustomSelect = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const SelectHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.primaryText};
  cursor: pointer;
  font-size: 14px;
  min-height: 32px;
  width: auto;
  max-width: 120px;

  &:hover {
    border-color: ${({ theme }) => theme.colors.secondaryLink};
  }
`;

export const SelectDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background-color: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10000;
  margin-top: 4px;
  padding: 4px;
  display: flex;
  gap: 4px;
`;

export const SelectOption = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.foreground};
  }
`;

export const ColorBox = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${({ color }) =>
    color === 'transparent' || !color ? 'transparent' : color};
  border: 2px solid ${({ theme }) => theme.colors.border};
  position: relative;
`;

export const ButtonContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
`;

export const SaveButton = styled(Button)`
  border-radius: 6px;
  cursor: pointer;
  border: none;
  background: #007bff;
  color: white;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  width: auto;
  max-width: 100px;
  margin-left: auto;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:not(:disabled):hover {
    background: #0056b3;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 32px;
  color: ${({ theme }) => theme.colors.primaryText};
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  font-weight: 400;

  &:hover {
    background-color: ${({ theme }) => theme.colors.foreground};
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 2px;
`;
